import type {
  IJournalComment,
  IJournalArticleUser,
} from '@/entities/journal/model/types';
import type { IUser } from '@/entities/user/model/types/user';
import type { ArticleCommentView } from '@/pages/journalArticle/model/types/articleComments';

export const toArticleCommentUser = (user: IUser): IJournalArticleUser => ({
  id: user.id,
  name: user.name,
  surname: user.surname,
  middlename: user.middlename ?? undefined,
  avatar: user.avatar,
  lawyer: user.lawyer
    ? {
        id: user.lawyer.id,
        user_id: user.lawyer.user_id,
        slug: user.lawyer.slug ?? '',
        name: user.lawyer.name,
        surname: user.lawyer.surname,
        role: user.lawyer.role,
        company_id: user.lawyer.company_id,
        company: user.lawyer.company,
        feedbackCount: user.lawyer.feedbackCount ?? 0,
      }
    : null,
});

export const mapArticleComment = (comment: IJournalComment): ArticleCommentView => {
  const reply = comment.children?.[0];

  return {
    id: comment.id,
    fullText: comment.text ?? '',
    createdAt: comment.created_at,
    updatedAt: comment.updated_at,
    creator: comment.user ?? null,
    review: reply?.text ?? '',
    target: reply?.user ?? null,
    replyId: reply?.id,
  };
};
